import React from 'react';
import PropTypes from 'prop-types';

const BasicSchemeForm = ({ formData, errors, onChange, disabled = false }) => {
  const handleInputChange = (field, value) => {
    onChange(field, value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return dateString.split('T')[0]; // Extract YYYY-MM-DD part
  };

  return (
    <div className="bg-white dark:bg-shoorah-darkBgTabColor border border-gray-300 dark:border-gray-600 rounded-2xl p-6 space-y-6">
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
        Basic Scheme Information
      </h2>

      {/* Company ID - Hidden field or read-only */}
      {/* <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Company ID <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          className="w-full rounded-lg px-4 py-2 bg-gray-100 dark:bg-gray-700 border-[1.5px] border-gray-300 dark:border-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed"
          placeholder="Company ID (Auto-assigned)"
          value={formData.companyId || ''}
          disabled={true}
          readOnly
        />
        {errors.companyId && <p className="text-red-500 text-sm mt-1">{errors.companyId}</p>}
      </div> */}

      {/* Date Range */}
      <div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">Scheme Duration</h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Start Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Start Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              value={formatDate(formData.startDate)}
              onChange={(e) => handleInputChange('startDate', e.target.value)}
              disabled={disabled}
            />
            {errors.startDate && <p className="text-red-500 text-sm mt-1">{errors.startDate}</p>}
          </div>

          {/* Expiry Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Expiry Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              value={formatDate(formData.expiryDate)}
              onChange={(e) => handleInputChange('expiryDate', e.target.value)}
              disabled={disabled}
              min={formatDate(formData.startDate)}
            />
            {errors.expiryDate && <p className="text-red-500 text-sm mt-1">{errors.expiryDate}</p>}
          </div>
        </div>
      </div>

      {/* Billing Amount */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Billing Amount <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
            £
          </span>
          <input
            type="number"
            min="0"
            step="0.01"
            className="w-full rounded-lg px-4 py-2 pl-8 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
            placeholder="0.00"
            value={formData.billingAmount || ''}
            onChange={(e) => handleInputChange('billingAmount', parseFloat(e.target.value) || 0)}
            disabled={disabled}
          />
        </div>
        {errors.billingAmount && (
          <p className="text-red-500 text-sm mt-1">{errors.billingAmount}</p>
        )}
      </div>

      {/* Provider Information */}
      <div>
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
          Provider Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Provider Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Provider Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              placeholder="Enter provider name"
              value={formData.providerName || ''}
              onChange={(e) => handleInputChange('providerName', e.target.value)}
              disabled={disabled}
            />
            {errors.providerName && (
              <p className="text-red-500 text-sm mt-1">{errors.providerName}</p>
            )}
          </div>

          {/* Provider Contact */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Provider Contact <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              placeholder="+91-1234567890"
              value={formData.providerContact || ''}
              onChange={(e) => handleInputChange('providerContact', e.target.value)}
              disabled={disabled}
            />
            {errors.providerContact && (
              <p className="text-red-500 text-sm mt-1">{errors.providerContact}</p>
            )}
          </div>
          {/* Provider Email */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Provider Email
            </label>
            <input
              type="email"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              placeholder="provider@example.com"
              value={formData.providerEmail || ''}
              onChange={(e) => handleInputChange('providerEmail', e.target.value)}
              disabled={disabled}
            />
            {errors.providerEmail && (
              <p className="text-red-500 text-sm mt-1">{errors.providerEmail}</p>
            )}
          </div>
          {/* Provider Website */}
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Provider Website
            </label>
            <input
              type="url"
              className="w-full rounded-lg px-4 py-2 bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none focus:ring-2 focus:ring-shoorah-primary"
              placeholder="https://www.example.com"
              value={formData.providerWebsite || ''}
              onChange={(e) => handleInputChange('providerWebsite', e.target.value)}
              disabled={disabled}
            />
            {errors.providerWebsite && (
              <p className="text-red-500 text-sm mt-1">{errors.providerWebsite}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

BasicSchemeForm.propTypes = {
  formData: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

BasicSchemeForm.defaultProps = {
  errors: {},
  disabled: false
};

export default BasicSchemeForm;
